import { _ } from "libs";

import React from "react";
import withRedux from "../../withRedux";
import { Championship, Match } from "../../types";
import Modal from "../modal";
import { closeChampionshipPlayerPopup, getMatches } from "../../actions";
import { RootState } from "../../reducers";
import { ChallengeTemplate, ChallengesList } from "../leaderboards/challenges";
import { MatchesList } from "../leaderboards/matches";

function PlayerChampionshipModal({
	show = false,
	championship = null,
	contextParams = null,
	playerId = null,
}: {
	show: boolean;
	championship: Championship;
	contextParams?: any;
	playerId?: string;
}) {
	if (show === false) {
		return null;
	}

	const close = () => {
		closeChampionshipPlayerPopup();
	};

	return (
		<Modal
			onBackClicked={contextParams?.backAction}
			onInfoClicked={contextParams?.infoAction}
			title={championship.name}
			largeTitle={true}
			onCloseClicked={close}
			fullHeight={true}
		>
			<div className="matches">
				<div className="sectionHeader">{_("championship.playedMatches.heading")}</div>
				<MatchesList
					championshipId={championship.uuid}
					viewForPlayerId={playerId}
					showPractice={false}
					showUnconfirmed={false}
				/>
			</div>
			{championship.challenges?.length > 0 && (
				<div className="challenges">
					<div className="sectionHeader">{_("championship.completedChallenges.heading")}
					</div>
					<ChallengesList
						challenges={championship.challenges}
						showIncomplete={false}
						template={ChallengeTemplate.BASIC}
					/>
				</div>
			)}
		</Modal>
	);
}

function mapStateToProps({ playerChampionshipModal: { show, championship, contextParams, playerId } }: RootState) {
	return { show, championship, contextParams, playerId };
}

export default withRedux({}, mapStateToProps)(PlayerChampionshipModal);
